
const styles = {
  colors: {
    powderWhite: "#FFFDF9",
    persianGreen: "#06B49A",
    lightBlue: "#AFDBD2",
    onyx: "#36313D",
    darkOnyx: "#28242d",
    darkBlue: "#0E1B2A",
    lightGrey: "#F2F2F2",
    mediumGrey: "#EAEEF4",
    darkGrey: "#cccccc",
    lightRed: "#FF5252",
    darkRed: "#B71C1C",
    lightGreen: "#00E676",
  },
  fonts: {
    primary: "sans-serif",
    secondary: "sans-serif",
  },
  fontSizes: {
    small: "1em",
    medium: "2em",
    large: "3em"
  }
}

const themes = {
  light: {
    colors: {
      primary: styles.colors.powderWhite,
      invertedPrimary: styles.colors.onyx,
      accent: styles.colors.darkGrey,
      secondary: styles.colors.lightGrey,
      background: styles.colors.powderWhite,
      text: styles.colors.onyx,
      inputBackground: styles.colors.mediumGrey,
      success: styles.colors.lightGreen,
      error: styles.colors.lightRed,
      focusOutline: `2px solid ${styles.colors.darkRed}`,
    },
    fonts: styles.fonts,
    fontSizes: styles.fontSizes
  },
  dark: {
    colors: {
      primary: styles.colors.onyx,
      invertedPrimary: styles.colors.powderWhite,
      accent: styles.colors.darkOnyx,
      secondary: styles.colors.darkOnyx,
      background: styles.colors.onyx,
      text: styles.colors.powderWhite,
      inputBackground: styles.colors.mediumGrey,
      success: styles.colors.lightGreen,
      error: styles.colors.lightRed,
      focusOutline: `2px solid ${styles.colors.lightBlue}`,
    },
    fonts: styles.fonts,
    fontSizes: styles.fontSizes
  }
}

export { themes, styles }